export default __webpack_public_path__ + "static/media/effect-512.fade47df.mp3";